export default {
  methods: {
    /**
     * Valida sí el pago inicial de un proyecto ya se realizó.
     * C262 debe tener el status 1.
     * @param var projectId
     */
    async validateInitialPayment(projectId) {
      try {
        const res = await axios.get(`/api/project/${projectId}/validate-initial-payment`);
        return res.data;
      }
      catch (e) {
        return null;
      }
    },

    /**
     * Valida sí el pago inicial de un proyecto ya se realizó.
     * C262 debe tener el status 1.
     * @param var projectId
     */
    async validateRgFinalBalance(projectId) {
      try {
        const res = await axios.get(`/api/project/${projectId}/validate-rg-can-invest`);
        return res.data;
      }
      catch (e) {
        return null;
      }
    },

    /**
     * Valida sí ya tiene garantías asociadas al proyecto.
     * @param var projectId 
     */
    async validateLoanGuarantee(projectId) {
      try {
        const res = await axios.get(`/api/get/loan-guarantees/by-project/${projectId}`);
        return res.data.length > 0;
      }
      catch (e) {
        return null;
      }
    },

    //#region Aprobación de proyectos

    /**
     * Valida sí el saldo insoluto del cliente no es mayor al autorizado.
     * @param var projectId 
     */
    async validateDebitBalance(projectId) {
      try {
        const res = await axios.get(`/api/project/${projectId}/validate-debit-balance`);
        return res.data;
      }
      catch (e) {
        return null;
      }
    },

    /**
     * Valida sí el proyecto no supera los 250 mil udis para no notariar los contratos.
     */
    async validateProjectAmountUdis(finances, udisValue, maxUdis) {
      try {
        const maxUdisAmountMXN = udisValue * maxUdis;
        return (finances.financed_amount < maxUdisAmountMXN);
      }
      catch (e) {
        return null;
      }
    },

    /**
     * Valida si los Os ya tienen la consulta de historial cdc y su identidad verificada.
     * @param {*} projectId 
     */
    async validateGuaranteesIdentities(projectId) {
      try {
        const res = await axios.get(`/api/project/${projectId}/validate-guarantees`);
        return res.data;
      } catch (error) {
        return false;
      }
    },
    //#endregion

    //#region Validaciones de publicación de crédito
    
    /**
     * Valida los límites del crédito del cliente según Art.47 CUITF
     * @param {int|string} projectId 
     * @param {int|string} clientId
     */
    async validateLoanLimitsCUITF47(projectId, clientId) {
      try {
        const res = await axios.post(`/api/project/validation/loan-limits-cuitf47`, {
          loan_id: projectId,
          client_id: clientId
        });
        return res.data;
      } catch (error) {
        return false;
      }
    }

    //#endregion
  }
}